import { IconName } from '@fortawesome/fontawesome-common-types'

export const POST_ARTICLE_HEIGHT = 350
export const AUTO_POST_ARTICLE_HEIGHT = 240

export const MAX_TITLE_LENGTH = 60

export const GALLERY_ITEMS_LENGTH = 5

export const REGEXP_BASE64 = /<p><img src="data:image\/\w+;base64,.+">&nbsp;<\/p>/g

export const QUILL_ERRORS = {
  ON_ADD: 'Error on adding story',
  BASE64: 'Incorrect image format. Please don\'t paste images from .docx files'
}

export const iconNames: Record<string, IconName> = {
  pin: 'thumbtack',
  edit: 'pencil',
  delete: 'trash-can',
  share: 'share-from-square',
  decline: 'trash-can',
  accept: 'share-from-square',
}
